import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ROUTES } from 'Utils/constants';
import { cn } from 'Utils/cn';
import logoImage from 'assets/logo.png';
import faviconImage from 'assets/favicon.png';
import AuthLayoutDecoration from './AuthLayoutDecoration';
import AuthLayoutLocaleSwitcher from './AuthLayoutLocaleSwitcher';

export default function AuthLayout(props) {
    const { children, title, description, variant = 'split', image, disabledLinkLogo = false } = props;

    const isMinimal = variant === 'minimal';

    const headerImage = isMinimal ? image || faviconImage : logoImage;
    const headerImageNode = (
        <img
            src={headerImage}
            alt="Banktrack"
            className={cn('block h-auto', isMinimal ? 'h-16 w-auto' : 'w-[164px]')}
        />
    );

    return (
        <main className={cn('grid min-h-dvh place-items-center', !isMinimal && 'min-[1200px]:grid-cols-[3fr_7fr]')}>
            {!isMinimal && <AuthLayoutDecoration />}

            <div
                className={cn(
                    'mx-auto w-full px-4 pt-6 pb-15',
                    isMinimal ? 'max-w-[400px] py-6' : 'max-w-[360px] min-[1200px]:max-w-[460px] md:pb-8',
                )}
            >
                <div className={cn('mb-10', isMinimal ? 'text-center' : 'min-[1200px]:mb-16 min-[1200px]:text-center')}>
                    <div className={cn('mb-6', isMinimal ? 'flex justify-center' : 'min-[1200px]:hidden')}>
                        {disabledLinkLogo ? (
                            headerImageNode
                        ) : (
                            <Link to={isMinimal ? ROUTES.signIn : ROUTES.landing}>{headerImageNode}</Link>
                        )}
                    </div>

                    <h1
                        className={cn(
                            'mb-1 font-semibold tracking-tight text-dark-blue',
                            isMinimal
                                ? 'text-[30px] leading-[1.26]'
                                : 'text-[27px] leading-[1.26] min-[1200px]:text-[37px]',
                        )}
                    >
                        {title}
                    </h1>
                    {description && <p className="text-sm text-gray-500 min-[1200px]:text-base">{description}</p>}
                </div>

                <div className={cn('mx-auto w-full', !isMinimal && 'max-w-[360px]')}>{children}</div>
            </div>

            {!isMinimal && <AuthLayoutLocaleSwitcher />}
        </main>
    );
}

AuthLayout.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    variant: PropTypes.oneOf(['split', 'minimal']),
    image: PropTypes.string,
    disabledLinkLogo: PropTypes.bool,
};
